import { render, staticRenderFns } from "./TwoColumnContent.vue?vue&type=template&id=53c125d6&"
import script from "./TwoColumnContent.vue?vue&type=script&lang=js&"
export * from "./TwoColumnContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports